// @flow

import fetchUrl, { fetchJson } from 'utils/fetch';
import URI from 'urijs';

type FetchProps = {
  thread: string,
  startIndex?: number,
  endIndex?: number,
};

export const fetchMessages = ({ thread, startIndex, endIndex }: FetchProps) => {
  const uri = new URI(`/mc/messaging/threads/${thread}/messages.json`)
    .search({
      starting_after: startIndex,
      ending_before: endIndex,
    })
    .toString();

  return fetchJson(uri);
};

type SendProps = {
  thread: string,
  content: string,
  files: Array<File>,
};

export const sendMessage = ({ thread, content, files }: SendProps) => {
  const data = new FormData();
  if (content.length > 0) {
    data.append('content', content);
  }
  files.forEach(file => {
    data.append(file.name, file);
  });

  return fetchUrl(`/mc/messaging/threads/${thread}/messages`, {
    method: 'POST',
    body: data,
    headers: {
      Accept: 'application/json',
    },
  }).then(res => res.json());
};



// WEBPACK FOOTER //
// ./src/modules/messaging/api/messages.js